import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function taskReducer(state = initialState.tasks, action) {
    let newState = state;

    switch (action.type) {
        case types.CLOSE_TASK:
            if (action.status === 'success'){
                newState = closeTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CREATE_TASK:
            if (action.status === 'success'){
                newState = createTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CREATE_TIMER:
            if (action.status === 'success'){
                newState = createTimer(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_FAVORITE_TASK:
            if (action.status === 'success'){
                newState = deleteFavoriteTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_TASK:
            if (action.status === 'success'){
                newState = deleteTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.EDIT_TASK:
            if (action.status === 'success'){
                newState = editTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.IS_DELETABLE_TASK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    deletable: action.data,
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                });
            }
            return newState;

        case types.LOAD_FAVORITE_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    favoriteTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_MOST_FREQUENTLY_USED_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    mostFrequentlyUsedTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_OTHER_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    otherTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_RECENTLY_ASSIGNED_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    recentlyAssignedTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    tasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_TASKS_ASSIGNABLE_TO_USER_BY_PROJECT:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    tasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_TASKS_BY_PROJECT:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    tasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_TASKS_BY_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    tasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PM_LOAD_ALL_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    allTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_ALL_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    allTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.REOPEN_TASK:
            if (action.status === 'success'){
                newState = reopenTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_COLOR_TASK:
            if (action.status === 'success'){
                newState = setColorTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_FAVORITE_TASK:
            if (action.status === 'success'){
                newState = setFavoriteTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_TASK_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        case types.SET_SELECTED_TASK:
            return Object.assign({}, state, {
                selectedTask: action.task
            });

        default:
            return state;
    }
}

function closeTask (state, taskID) {
    let taskIndex = list.findIndexByID(state.tasks, taskID);
    let newTasks = state.tasks.slice(0);
    newTasks[taskIndex].closed = true;

    return Object.assign({}, state, {
        loading: false,
        tasks: newTasks
    });
}

function createTask (state, task) {
    return Object.assign({}, state, {
        loading: false,
        tasks: [...state.tasks, task]
    });
}

function createTimer (state) {
    return Object.assign({}, state, {
        loading: false,
    });
}

function deleteFavoriteTask (state, task) {
    let favoriteTasks = state.favoriteTasks;
    let mostFrequentlyUsedTasks = state.mostFrequentlyUsedTasks;

    mostFrequentlyUsedTasks.push(task);
    let index = list.findIndexByID(favoriteTasks, task.id);
    favoriteTasks = list.remove(favoriteTasks, index);

    return Object.assign({}, state, {
        favoriteTasks: favoriteTasks,
        mostFrequentlyUsedTasks: mostFrequentlyUsedTasks,
        loading: false
    });
}

function deleteTask (state, taskID) {
    let taskList = state.tasks;
    let index = list.findIndexByID(taskList, taskID);

    taskList = list.remove(taskList, index);

    return Object.assign({}, state, {
        loading: false,
        tasks: taskList
    });
}

function editTask (state, task) {
    let taskList = state.tasks;
    let index = list.findIndexByID(taskList, task.id);

    taskList[index] = task;

    return Object.assign({}, state, {
        loading: false,
        tasks: taskList
    });
}

function reopenTask (state, taskID) {
    let taskList = state.tasks;
    let index = list.findIndexByID(taskList, taskID);

    taskList[index].closed = false;

    return Object.assign({}, state, {
        loading: false,
        tasks: taskList
    });
}

function setColorTask (state, task) {
    return editTask(state, task);
}

function setFavoriteTask (state, task) {
    let favoriteTasks = state.favoriteTasks;
    let mostFrequentlyUsedTasks = state.mostFrequentlyUsedTasks;
    let otherTasks = state.otherTasks;
    let recentlyAssignedTasks = state.recentlyAssignedTasks;

    favoriteTasks.push(task);

    let index = list.findIndexByID(mostFrequentlyUsedTasks, task.id);
    if (index === -1) {
      index = list.findIndexByID(otherTasks, task.id);
      if (index === -1){
        index = list.findIndexByID(recentlyAssignedTasks, task.id);
        recentlyAssignedTasks = list.remove(recentlyAssignedTasks, index);
      } else {
        otherTasks = list.remove(otherTasks, index);
      }
    } else {
      mostFrequentlyUsedTasks = list.remove(mostFrequentlyUsedTasks, index);
    }

    return Object.assign({}, state, {
        favoriteTasks: favoriteTasks,
        mostFrequentlyUsedTasks: mostFrequentlyUsedTasks,
        otherTasks: otherTasks,
        recentlyAssignedTasks: recentlyAssignedTasks,
        loading: false
    });
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/taskReducer.js
 **/